import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from '.../../environments/environment';
import { Broadcaster } from '.../../environments/broadcaster';
import { AuthService } from '../../../_services/index';
import { LoaderService } from 'app/_services/loader.service';
import { utils, write, WorkBook } from 'xlsx';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2'
import { CompileMetadataResolver } from '@angular/compiler';
declare var $: any;

@Component({
  selector: 'route-plans',
  templateUrl: './routeplan.component.html',
  styleUrls: ['./routeplan.component.css'],
})

export class RoutePlanComponent implements OnInit {
  map: any
  showLoader: boolean;
  public Id;
  public data : any;
  public userId: any;
  public areaEntityData;
  public staffEntityData;
  public prjData;
  public vehNo;
  public VehiclesByID;
  public VehiclesDataStatus;
  selectedRow: Number;
  selectedAreaRow: Number;
  setClickedRow: Function;
  selectAreaEntityDetailsRow: Function;
  //selectStaffEntityDetailsRow :Function;
  public vehiclesCatogery;
  public vehiclesArealabel: any;
  public stdate: any
  public enddate: any
  public selectPrjId: any
  public SelectVehno: any
  public deleted = false;
  public delwarning = false;
  public updtVehDataSuccess = false;
  public VehicleParkLocation: any
  public selectProjectmodel: any
  public vehAreaModel: any
  public vehiclesAreaEntity: any
  public vehAssignmtStaffRole: any
  public vehStaffRoleModel: any
  public staffRole: any
  public staffNameData: any
  public areaAssignDetails: any
  public staffAssignDetails: any
  public vehStaffNameModel: any
  public vehStaffAsignStatus: any
  search: any;
  showDialog: any
  visible: any
  //---------------vehicles Update Details-------------
  //For Update validations  
  public udptVehTypename = false;
  public updtImeiNo = false;
  public udptParkLocation = false;
  public udptDataStatus = false;
  public saveAreaEntityStatus = false;
  public saveStaffNameStatus = false;
  public deleteAreaEntity = false;
  public vehStaffRoleStatus = false;
  public vehStaffRoleNameStatus = false;
  public isVehAssignSave = false;
  public isStaffAssignSave = false;
  public vehiclesNo: any
  public vehTypId: any
  public vehType: any
  public vehCotegaryId: any
  public vehiclesType: any;
  public inActiveVehiclesLst: any;
  public SelectProjectName: any
  public vehCotId: any
  public vehTypeId: any
  public VehiclesNo: any
  public imeidNo: any
  public chaChihNo: any
  public vtsMobileNo: any
  public simNo: any
  public vtsModel: any
  public parkLocations: any
  public installDate: any
  public activationsDate: any
  public vehDataStatus: any
  public isjingleActive: any
  public isActiveStatus: any
  public selectedRowData: any
  public Prjid: any
  public updtCheckVehnoAvl: any
  public updtCheckVehMobileImeiNoAvl: any
  public updtCheckVtsMobileNoAvt: any
  public updtCheckVehChasisNoAvt: any
  public updtCheckSimNoAvt: any
  public vehCatArea: any
  public vehlabelId: any
  public vehEntityArea = false;
  public vehStaffStatus = false;
  public vehAreaEntityModel: any
  public vehEntityData: any
  public vehAreaAsignStatus: any
  public vehStaffRoleId: any
  public project: any
  public updateData: any
  public updtVstDeviceNo: any
  public updtGsmOperator: any
  public updtEntryDate: any
  public currentDate: any
  public projectMaster: any;
  public showHideVehAssignLoadDiv = false;
  public showHideStaffAssignLoadDiv = false
  public imageVehAssignLoader: any;
  public imageStaffAssignLoader: any;
  public vehUpdateBtnDiv = false;
  public vehDeleteBtnDiv = false;
  public vehAssignmentBtnDiv = false;
  public vehActiveBtnDiv = false;
  public showHideVehNoDiv = false;
  public isVehicleUpdtbtn = false;
  public showHideImeiNoDiv = false;
  public imgVehNoPath: any;
  public imgVehImeiNoPath: any;
  public showHideChasisNoDiv: any;
  public imgChasisNoPath: any;
  public imgVtsMobilNoPath: any;
  public showHideVtsMobileDiv = false;
  public imgSimNoPath: any;
  public showHideSimNoDiv = false;
  public employeeRecordNotFound = false;
  public vehAreaRecordNotFound = false;
  public staffAssignReNotFound = false;
  public vehID: any;
  //public staffSelectionsId:any;
  public vtsModalaData: any;
  public vtsData: any;
  public vehOwnerTypeList: any;
  public ownerType: any;
  public VehiclesTempNo: any;
  public vehOwnerTypeData: any;
  public ownerNameModal: any;
  public vtsModal: any;
  public vehOwnerRequired = false;
  public vtsModelRequired = false;
  public updtResponceMsg: any;
  public updtVehDataError = false;
  public saveAreaEntityError = false
  public saveStaffNameError = false;
  routeBoundary;
  changeStatus: any;
  status: any;
  titleData: any;
  successMsg: any;
  currentVehicleId: any;
  driverHistoryData: any;
  routeSelected: boolean;
  beatDetails: any;
  beatName: any;
  routeDetails: any;
  isBeatNull: boolean;
  routeList: any;
  isRouteSelected: boolean;
  singleRouteDetails: any;
  isNameUpdating: boolean;
  routeName: any;
  updateNameSuccess: boolean;
  updateNameError: boolean;
  selectedRouteId: any;

  //Edit modal variable by craeted atul start

  public editModalZone : any ;
  public editModalWard : any ;
  public editModalRoute : any ;
  public editModalBeatStart : any ;
  public editModalBeatEnd : any ;
  public editModalTimeStart : any ;
  public editModalTimeEnd : any ;
  public editModalVehnoID:any;
  public isSubmmit = true ;

  public editZone : any ;
  public editWard : any ;
  public editRoute : any ;
  public editBeatStart : any ;
  public editBeatEnd : any ;
  public editTimeStart : any ;
  public editTimeEnd : any ;
  public zoneId :  any ;
  public wardId :  any;
  public editTS : any ;
  public editVeh : any;

  public transfer_s : any ;

 
  //edit message 

  public editSuccess : any ;
  public editError  : any ;
  public ZoneData : any ;
  public WardData : any ;
  editModalZoneActive: any;
  editModalWardActive: any;
  newAddZone: any;
  newAddWard: any;


  public EditNew : boolean;

  public EditButton : boolean;
  public editModalTransferS: any;
  editModalVehNumber: any;
  public transfer_station: any;
  AllVehicle: Object;





 //Edit modal variable by craeted atul end

  constructor(private http: HttpClient, private broadcaster: Broadcaster, private auth: AuthService, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.vehOwnerTypeList = [{ "ID": 1, "VALUE": "Ecogreen" }, { "ID": 2, "VALUE": "Contractor" }]
  }
  ngOnInit(): void {

     
    
    $("#progress-bar").hide()
    this.Prjid = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id;
    if (this.Prjid == 1) {
      this.SelectProjectName = "LUCKNOW";
    } else if (this.Prjid == 2) {
      this.SelectProjectName = "GURUGRAM";
    } else if (this.Prjid == 3) {
      this.SelectProjectName = "FARIDABAD";
    } else if (this.Prjid == 4) {
      this.SelectProjectName = "GWALIOR";
    }
  
    this.getAllVehiclesDetails()
    
  }
 
  
  getAllVehiclesDetails() {
    this.loaderService.display(true);
    console.log('data get ng on init')
    $('button').click( function() {
      $(this).addClass('btn-primary').removeClass('btn-default').siblings().removeClass('btn-primary').addClass('btn-default');
    });
    
    this.http.get(environment.apiUrl + 'admin/getVehiclesRoutePlans?prjid=' + this.Prjid).subscribe((data) => {
      this.data = data;
     
      
      
      if (this.data.length > 0) {
         this.loaderService.display(false);
      }
      else {
         this.loaderService.display(false);
      }
    });
  } 
 
  importVehiclesExcelReport(data) {
    const ws_name = 'VehicleReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, {
      bookType: 'xlsx', bookSST: true, type:
        'binary'
    });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'exported.xlsx');
  }

  s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xFF;
    };
    return buf;
  }






//Edit function by develop by atul start 

async selectEditMstrDetailsRow(data,index){

        console.log(data);
        this.editModalZoneActive =  data.zone;
        this.editModalWardActive =  data.ward;
        this.editModalRoute = data.route;
        this.editModalBeatStart = data.beat_start;
        this.editModalBeatEnd = data.beat_end;
        this.editModalTimeStart = data.timing_to;
        this.editModalTimeEnd = data.timing_from;
        this.editModalVehnoID   = data.id;
        this.transfer_station   = data.transfer_station
        this.isSubmmit = false ;
        this.EditNew = false ;
        this.EditButton = true ;

    

        $("#editModelPopup").modal("show");



        await this.getZonedata('edit');
        await this.getWarddata('edit');



       
 
}
  //Get the All Ward details details.
  async  getZonedata(type) {
              
          if (this.ZoneData  == null || this.ZoneData  == undefined || this.ZoneData  == "" || this.ZoneData  == "null") {
                    await   this.http.get(environment.apiUrl + 'admin/getAllZone').subscribe((data) => {
                     this.ZoneData = data;
                     if(type = 'edit'){
                     this.setZoneWardValues(this.ZoneData,this.editModalZoneActive,'zone')
                    }                                                                                                                })
              }
            else{
              if(type = 'edit'){
                this.setZoneWardValues(this.ZoneData,this.editModalZoneActive,'zone')
              } 
          }

  }

   
     
//Get the All Ward details details.
  async getWarddata(type) {
          
        if (this.WardData  == null || this.WardData  == undefined || this.WardData  == "" || this.WardData  == "null") {
                   await this.http.get(environment.apiUrl + 'admin/getAllWard').subscribe( (data) => {
                   this.WardData = data;
                   if(type = 'edit'){
                   this.setZoneWardValues(this.WardData,this.editModalWardActive,'ward')
                  }
                  })
                }
              else{ 
                if(type = 'edit'){
                    this.setZoneWardValues(this.WardData,this.editModalWardActive,'ward')
                 }
                }
      }



 async  setZoneWardValues(data , values, type) {
         var lenth = data.length
         for(var i= 0;i<=lenth-0;i++){
              console.log(data[i].ID)
              if(data[i].ID == values){

                if(type == 'zone')
                  {
                    this.editModalZone = data[i].ID
                  }else{
                    this.editModalWard = data[i].ID
                  }
                  
                    return ;
                 } 
  }
 }

onClickToEditRouteDetails(){
   this.onClickToSaveRouteDetails('edit');
}

 onClickToSaveRouteDetails(type){



  console.log('add save call');
  
  //zone
  if (this.editModalZone == null || this.editModalZone == undefined || this.editModalZone == "" || this.editModalZone == "null") {
    this.editZone = true;
    return;
  } else {
    this.editZone = false;
  }
  //ward
  if (this.editModalWard == null || this.editModalWard == undefined || this.editModalWard == "" || this.editModalWard == "null") {
    this.editWard = true;
    return;
  } else {
    this.editWard = false;
  }
  //route
  if (this.editModalRoute == null || this.editModalRoute == undefined || this.editModalRoute == "" || this.editModalRoute == "null") {
    this.editRoute = true;
    return;
  } else {
    this.editRoute = false;
  }
   //BeatStart
   if (this.editModalBeatStart == null || this.editModalBeatStart == undefined || this.editModalBeatStart == "" || this.editModalBeatStart == "null") {
    this.editBeatStart = true;
    return;
  } else {
    this.editBeatStart = false;
  }
  //BeatEnd
  if (this.editModalBeatEnd == null || this.editModalBeatEnd == undefined || this.editModalBeatEnd == "" || this.editModalBeatEnd == "null") {
    this.editBeatEnd = true;
    return;
  } else {
    this.editBeatEnd = false;
  }
   //Timestart
   if (this.editModalTimeStart == null || this.editModalTimeStart == undefined || this.editModalTimeStart == "" || this.editModalTimeStart == "null") {
    this.editTimeStart = true;
    return;
  } else {
    this.editTimeStart = false;
  }
   //TimeEnd
   if (this.editModalTimeEnd == null || this.editModalTimeEnd == undefined || this.editModalTimeEnd == "" || this.editModalTimeEnd == "null") {
    this.editTimeEnd = true;
    return;
  } else {
    this.editTimeEnd = false;
  }

  // transfer satation 
  if (this.transfer_station == null || this.transfer_station == undefined || this.transfer_station == "" || this.transfer_station == "null") {
    this.transfer_s = true;
    return;
  } else {
    this.transfer_s = false;
  }

  console.log(this.transfer_station );
  

   // add case 

    //  if(type == 'add'){
       
    //   if (this.editModalVehNumber == null || this.editModalVehNumber == undefined || this.editModalVehNumber == "" || this.editModalVehNumber == "null") {
    //     this.editTimeEnd = true;
    //     return;
    //   } else {
    //     this.editTimeEnd = false;
    //   }

    // }




  //jason edit
  var jsonEditData = {
    "vehID" :  this.editModalVehnoID ,
    "zone": this.editModalZone,
    "ward": this.editModalWard ,
    "route":  this.editModalRoute,
    "beatStart": this.editModalBeatStart,
    "beatEnd": this.editModalBeatEnd,
    "timeStart":this.editModalTimeStart ,
    "timeEnd": this.editModalTimeEnd ,
    "tstation" : this.transfer_station
     
  }

  console.log(jsonEditData) ;


  
  //json add
  if(type == 'add')
  var jsonAddData = {
    "VehNuber":this.editModalVehNumber,
    "zone": this.editModalZone,
    "ward": this.editModalWard ,
    "route":  this.editModalRoute,
    "beatStart": this.editModalBeatStart,
    "beatEnd": this.editModalBeatEnd,
    "timeStart":this.editModalTimeStart ,
    "timeEnd": this.editModalTimeEnd ,
    "tstation" : this.transfer_station,
    "vehID" :  this.editModalVehnoID 
  }

  console.log(jsonAddData);

  //api call to update or edit route
  if(type == 'edit') {
         this.http.post(environment.apiUrl + 'admin/editRouteMasterDetails', jsonEditData).subscribe((data) => {
         this.editSuccess = true;
         this.getAllVehiclesDetails();
   
         setTimeout(() => {
              $("#editModelPopup").modal("hide");
             this.editmessage()
            }, 2000);
         },error=>{
               this.editError = true ;
          })

  }

  if(type == 'add'){
    
    console.log(jsonAddData);

    this.http.post(environment.apiUrl + 'admin/addRouteMasterDetails', jsonAddData).subscribe((data) => 
         {
              this.editSuccess = true;
              this.getAllVehiclesDetails();

             setTimeout(() => {
                   $("#editModelPopup").modal("hide");
                 this.editmessage()
                }, 2000
              );
              
      },error=>{
            this.editError = true ;
       }
  )
  
  }

} 

 editmessage(){

  this.editZone = false;
  this.editWard = false ;
  this.editRoute = false ;
  this.editBeatStart = false ;
  this.editBeatEnd = false ;
  this.editTimeStart = false ;
  this.editTimeEnd = false ;
  this.editError = false ;
  this.editSuccess = false;


}
//Edit function by develop by atul end

//new  function to add new route by develop by atul start


editNull(){
  this.editModalRoute = null;
  this.editModalBeatStart = null;
  this.editModalBeatEnd = null;
  this.editModalTimeStart = null;
  this.editModalTimeEnd = null;
  this.editModalZone = null;
  this.editModalWard = null ;
  this.transfer_station = null,
  this.editModalVehNumber = null
  

  //this.editModalVehnoID   = null;

}
   
 addNewRoutes(){

  this.getWarddata('add');
  this.getZonedata('add');
  
  this.editNull()

  this.EditNew = true ;
  this.EditButton = false;
  this.isSubmmit = false ; 

 

  $("#editModelPopup").modal("show");


  if( this.AllVehicle  == null || this.AllVehicle  == undefined || this.AllVehicle  == "" || this.AllVehicle  == "null" ){
  this.http.get(environment.apiUrl + 'vehicles/all?prjId='+this.Prjid).subscribe((data) => {
      this.AllVehicle = data;
      })
  }

}

RouteDetails(){

  this.editModalRoute
  this.editModalBeatStart
  this.editModalBeatEnd
  this.editModalTimeStart
  this.editModalTimeEnd
  this.editModalZone 
  this.editModalWard
  this.editModalTransferS
  this.editModalVehNumber 
  
  this.onadd();


 

}

onadd(){
  this.onClickToSaveRouteDetails('add');
   
}





}


// WEBPACK FOOTER //
// ./src/app/admin/vehicles/vehicleRoutesMngt/routeplan.component.ts